<template>
  <div class="ui-page-thr">
    <div class="ui-flex" v-if="deviceList.length<7">
      <div class="ui-box" v-for="(item,key) in deviceList" :key="key">
        <div class="text-c">
            <div class="font-34 font-bold">{{item.value}}</div>
            <div class="font-12">{{item.name}}({{item.unit}})</div>
        </div>
      </div>  
    </div>
    <div class="ui-flex" v-else> 
      <div class="ui-box" v-for="(item,key) in deviceList1" :key="key">
        <div class="text-c">
            <div class="font-34 font-bold">{{item.value}}</div>
            <div class="font-12">{{item.name}}({{item.unit}})</div>
        </div>
      </div>   
      <div class="ui-device-list mar-l2" v-if="deviceList2.length>1">
        <swiper :options="swiperOption" :interval="10000" duration="2000" class="swiper-wrap" ref="mySwiper"> 
          <swiper-slide v-for="(item,key) in deviceList2" :key="key"> 
            <div class="ui-box">
              <div class="text-c">
                <div class="font-34 font-bold">{{item.value}}</div>
                <div class="font-12">{{item.name}}({{item.unit}})</div>
              </div>
            </div> 
          </swiper-slide> 
        </swiper> 
      </div> 
      <div class="ui-device-list mar-l2" v-else>
        <div class="ui-box" v-for="(item,key) in deviceList2" :key="key">
          <div class="text-c">
            <div class="font-34 font-bold">{{item.value}}</div>
            <div class="font-12">{{item.name}}({{item.unit}})</div>
          </div>
        </div>
      </div> 
    </div>  
  </div>
</template>

<script>  
import { swiper, swiperSlide } from "vue-awesome-swiper";
require("swiper/dist/css/swiper.css"); 
import NumRollSec from '@/components/NumRollSec.vue'
export default { 
    props:{
        deviceInfo:{
          type:Array,
          default:[]
        },
        version:{
          type:String,
        },
    }, 
    components:{  
      NumRollSec,
      swiper, 
      swiperSlide,
    },
    data(){
      return{
        deviceList:[],
        deviceList1:[],
        deviceList2:[],
        swiperOption: {
          loop: true, 
          autoplay: {
              // delay: 10000,  
              stopOnLastSlide: false,
              /* 触摸滑动后是否继续轮播 */
              disableOnInteraction: false
          },   
          slidesPerView: 'auto',
          spaceBetween: 1, 
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper  
          //滑动速度
          speed: 5000,
        }, 
      }
    },
    watch:{
      deviceInfo(newVal){   
        this.deviceList = newVal; 
        if(this.deviceList && this.deviceList.length>6){
          this.deviceList1 = [];
          this.deviceList2 = [];
          this.deviceList.forEach((item,key)=>{  
            if(key<5){ 
              this.deviceList1.push(item) 
            } else { 
              this.deviceList2.push(item)
            }
          }) 
        }   
      }, 
    },
    methods:{

    }
}
</script>

<style lang="scss" scoped> 
.ui-page-thr{    
    // width: 100%;
    width: 69.5rem;  
    overflow: hidden;   
    .swiper-slide{  
      width: 50%!important;   
      height: 100%!important;  
    }
    .ui-device-list{
      width: 20rem;
      overflow: hidden;    
    }
    .icon-wh{ 
      height: 1.25rem; 
    }
    .ui-box{
      width: 8.25rem; 
    }
  .ui-thr-box{
      width: 7.5rem; 
      min-height: 4.375rem; 
      padding: 1.25rem;  
      border-radius: .5rem;  
      overflow: hidden;
  }
  .ui-thr-box1{
      width: 6.25rem; 
      min-height: 3.75rem; 
      padding: 1.25rem;  
      border-radius: .5rem;  
      overflow: hidden;
  }
  .ui-thr-box:nth-of-type(1),.ui-thr-box1:nth-of-type(1){
      margin-left: 0
  }
  .num-box{ 
    border-top: .05rem solid; 
    align-items: flex-end;
    border-image: linear-gradient(90deg, transparent 0%,#77A6D1 56%,transparent 100% ) 1; 
    min-height: 1.875rem; 
    max-height:  1.875rem; 
  }
  .pro-1{
    width: .8125rem;
    height: 1.0625rem;
  }
  .pro-2{
    width: 1.1875rem;
    height: 1rem;
  }
  .pro-3{
    width: 1.25rem;
    height: 1.0625rem;
  }
  .pro-4{
    width: 1rem;
    height: 1.0625rem;
  }
  .pro-5{
    width: 1.0625rem;
    height: 1.0625rem;
  }
  .dev-1{
    width: .8125rem;
    height: 1.0625rem;
  }
  .dev-2{
    width: 1.0625rem;
    height: 1.125rem;
  }
  .dev-3{
    width: 1.0625rem;
    height: 1.25rem;
  }
  .dev-4{
    width: 1.1875rem;
    height: 1.1875rem;
  }
  .dev-5{
    width: 1.3125rem;
    height: 1.25rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TypeList.vue